<div class="filtro-cargos-contatos flex-col gap-6 flex">
    <div class="filtros__header flex items-center justify-between">
        <h3 class="text-sm font-medium text-brand-purple-300">{{ titulo }}</h3>
        <div class="actions flex items-center gap-4">
            <button class="text-brand-primary" (click)="removerFiltro(undefined, true)" *ngIf="permiteExcluirTodos">
                <span class="material-symbols-outlined filled">
                    delete
                </span>
            </button>
            <button class="text-brand-primary" (click)="cancelarFiltro()">
                <span class="material-symbols-outlined">
                    close
                </span>
            </button>
        </div>
    </div>
    <div class="filtros__conteudo flex-1">
        <p class="font-semibold">{{ subTitulo }}</p>

        <p class="text-brand-gray-400 mt-4" *ngIf="loading">Carregando...</p>

        <div class="flex flex-col space-y-6 mt-6 container-checkbox" *ngIf="!loading">
            <label class="text-sm text-brand-gray-400" *ngFor="let item of opcoesDisponiveis">
                <input type="checkbox" (change)="adicionarRemoverFiltro(item)" [checked]="verificarItensSelecionados(item)">
                {{ item.valor }}
            </label>            
        </div>
    </div>
    <footer class="filtros_footer flex items-center justify-between gap-2">
        <button class="btn btn-secondary flex-1" (click)="cancelarFiltro()">Cancelar</button>
        <button class="btn btn-primary flex-1" (click)="salvarFiltro()">OK</button>
    </footer>
</div>